import * as React from 'react';

import { AnalyticsStore, RouteStore } from 'bernie-core';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';

import { GalleryViewModel, ImageViewModel, RoomViewModel } from 'src/common/models';

import { DialogTrigger } from 'components/infosite/property-details/dialog-trigger';

export interface DialogTriggerWrapperProps {
  additionalClasses?: string;
  analytics?: AnalyticsStore;
  className?: string;
  currentIndex?: number;
  currentHotel?: CurrentHotelStore;
  clickHandler?: () => void;
  displayImageCount?: boolean;
  gallery?: GalleryViewModel;
  galleryTitle?: string;
  id?: string;
  images: ImageViewModel[];
  infositeGallery?: boolean;
  onIndexChange?: (index) => void;
  position: string;
  room: RoomViewModel;
  routeStore?: RouteStore;
  showThumbnail?: boolean;
  trackingRfrr?: string;
  triggerId?: string;
}

export const DialogTriggerWrapper = (props: DialogTriggerWrapperProps) => {
  const { displayImageCount, images, position, room } = props;
  const roomTypeCode = room && room.roomTypeCode;
  const triggerMessage = (displayImageCount && images && `${images.length - 1}+ `) || '';

  if (!room) {
    return null;
  }

  return (
    <DialogTrigger
      {...props}
      className={`${props.additionalClasses} uitk-grid room__gallery-trigger`}
      queryParam={roomTypeCode && `roomInfo-${roomTypeCode}-${position}`}
      triggerMessage={triggerMessage}
      trackingRfrr={`.Room.InfoDialog.PhotoGallery${position}`}
    />
  );
};

DialogTriggerWrapper.displayName = 'DialogTriggerWrapper';
